// client/src/auth.js

// --- helpers ---
function getToken() {
  return localStorage.getItem('token');
}

function setToken(token) {
  if (token) localStorage.setItem('token', token);
}

function logout() {
  localStorage.removeItem('token');
  // simple way to clear state and force re-render to Login
  window.location.reload();
}

function decodeJwt(token) {
  try {
    const [, payload] = token.split('.');
    // add padding for base64 if needed
    const normalized = payload.padEnd(payload.length + (4 - (payload.length % 4)) % 4, '=');
    return JSON.parse(atob(normalized));
  } catch (e) {
    return null;
  }
}

// --- named exports exactly as your components expect ---
export const auth = { getToken, setToken, logout };
export { decodeJwt };